module.exports = __webpack_public_path__ + "img/logo@3x.2444df3e.png";